import { create } from "zustand";

type SensorImageNoticeState = {
  noImagesForDate: boolean;
  noRawSensorImages: boolean;
  setNoImagesForDate: (noImagesForDate: boolean) => void;
  setNoRawSensorImages: (noRawSensorImages: boolean) => void;
  clearNotices: () => void;
};

export const useSensorImageNotice = create<SensorImageNoticeState>((set) => ({
  noImagesForDate: false,
  noRawSensorImages: false,
  setNoImagesForDate: (noImagesForDate) => set({ noImagesForDate }),
  setNoRawSensorImages: (noRawSensorImages) => set({ noRawSensorImages }),
  clearNotices: () => set({ noImagesForDate: false, noRawSensorImages: false }),
}));
